import React, { useState, useEffect, useContext } from "react";
import classnames from "classnames";
import { useHistory } from "react-router-dom";
import { formatPhoneNumber } from "../common/js/util";
import MessageBox from "../../../components/message-box";
import {
  Context,
  DEFAULT_SERVICE_CALL_NUMBER,
  MIN_SCREEN_HEIGHT,
} from "../common/js/constant";
import { resetFormData } from "../common/actions";
import useBaseInfoHook from "../common/hooks/useBaseInfoHook";
import useRescueAddressHook from "../common/hooks/useRescueAddressHook";
import { queryRescueOrderList } from "../common/js/request";
import styles from "./index.module.scss";
import useTrailerAddress from "../common/hooks/useTrailerAddress";
import useUploadImages from "../common/hooks/useUploadImages";

export default function RescueHome() {
  const history = useHistory();
  const { dispatch, state } = useContext(Context);
  const [rulesChecked, setRulesChecked] = useState(false);
  const { resetBaseInfo } = useBaseInfoHook();
  const { resetAddressInfo } = useRescueAddressHook();
  const { resetTrailerAddressInfo } = useTrailerAddress();
  const { resetUploadImages } = useUploadImages();
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [pageConfig, setPageConfig] = useState({
    mobile: "",
    address: "",
  });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    document.title = "紧急救援";
    dispatch(resetFormData());
  }, [dispatch]);

  // 检查是否存在未完成订单，如果存在则跳转到救援状态页面
  useEffect(() => {
    const checkIncompleteOrder = async () => {
      try {
        const res = await queryRescueOrderList();
        if (res.data?.length) {
          history.replace("/rescue-new/status");
        }
        setLoading(false);
      } catch (error) {
        console.error("检查未完成订单失败:", error);
        setLoading(false);
      }
    };

    checkIncompleteOrder();
  }, [history]);

  useEffect(() => {
    setIsSmallScreen(window.innerHeight <= MIN_SCREEN_HEIGHT);
  }, []);

  useEffect(() => {
    resetBaseInfo();
    resetAddressInfo();
    resetUploadImages();
    resetTrailerAddressInfo();
  }, [
    resetBaseInfo,
    resetAddressInfo,
    resetUploadImages,
    resetTrailerAddressInfo,
  ]);

  useEffect(() => {
    setPageConfig(state.baseConfig);
  }, [state.baseConfig]);

  const onTapRulesAgreement = () => {
    setRulesChecked((preState) => !preState);
  };

  const onViewRulesDetail = (e) => {
    // 阻止合成事件冒泡
    e.stopPropagation();
  };

  // 跳转救援表单页
  const onTapApplyRescue = () => {
    if (!rulesChecked) {
      MessageBox.toast("请勾选按钮下方的授权信息");
      return;
    }
    history.push("/rescue-new");
  };

  if (loading) {
    return null;
  }

  return (
    <div
      className={classnames(`${styles["rescue-home-container"]}`, {
        [styles["small-screen-adapted"]]: isSmallScreen,
      })}
    >
      <div className={styles["home-banner"]} />

      <div className={styles["rescue-info-wrapper"]}>
        <div className={styles["rescue-title"]}>
          <span className={styles["hour-icon"]}>24h</span>
          <span>救援热线</span>
        </div>
        <div className={styles["content"]}>
          服务内容：全国范围为您提供24小时无忧救援服务，随时随地待命。
        </div>
        {!!pageConfig?.mobile && (
          <div className={styles["hotline-field"]}>
            <a
              className={styles["hotline-tap-wrapper"]}
              href={`tel:${pageConfig.mobile}`}
            >
              <svg
                className={styles["phone-icon"]}
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="32px"
                height="32px"
                viewBox="0 0 32 32"
                version="1.1"
              >
                <title>图标/48/常规/电话</title>
                <g
                  id="图标/48/常规/电话"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g>
                    <rect
                      id="矩形"
                      fillRule="nonzero"
                      x="0"
                      y="0"
                      width="32"
                      height="32"
                    />
                    <path
                      d="M18.8291116,21.2544222 L19.5618638,20.7934784 C19.8491649,20.6176837 20.0843996,20.4868057 20.3215851,20.3794008 C21.9798802,19.6137337 23.4453318,20.1547638 25.3813056,22.4478662 C26.5787537,23.8659205 26.9335434,25.1238021 26.4707719,26.2449574 C26.1275291,27.0828865 25.4642164,27.6610356 24.2821905,28.3739616 C24.2050795,28.4208544 23.5243937,28.8232088 23.3508478,28.9306404 C20.6011882,30.6494925 14.297753,26.715675 9.76444358,19.9926417 C5.2195609,13.252037 4.04333479,6.06418787 6.82963854,4.31991327 L7.19602782,4.08552921 L7.5970841,3.82185047 C9.00474866,2.89796014 9.90714506,2.52879924 10.9773139,2.71239163 C12.0455319,2.89796014 12.9537545,3.69879684 13.7192755,5.15589288 C15.3390019,8.24005815 14.9822614,9.70302915 12.8978391,11.0312233 C12.7474397,11.1288811 12.2152288,11.4550747 12.1651133,11.4863188 C11.6560489,11.8066642 12.5199029,13.9532665 14.5310632,16.9358484 C16.5692189,19.9516238 18.2718561,21.6021128 18.8291116,21.2505233 L18.8291116,21.2544222 Z"
                      id="路径"
                      stroke="#3B99FF"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </g>
              </svg>
              <span className={styles["hotline-text"]}>
                {formatPhoneNumber(
                  pageConfig.mobile || DEFAULT_SERVICE_CALL_NUMBER,
                )}
              </span>
            </a>
          </div>
        )}
      </div>

      <div className={styles["apply-rescue-field"]}>
        <div
          className={classnames(
            `
              ${styles["apply-rescue-btn"]}
            `,
            {
              [styles["apply-rescue-btn-disabled"]]: !rulesChecked,
            },
          )}
          onClick={onTapApplyRescue}
        >
          快速申请救援
        </div>
        <div
          className={styles["rules-agreement-wrapper"]}
          onClick={onTapRulesAgreement}
        >
          <i
            className={classnames(styles["rules-checkbox-icon"], {
              [styles["z-checked"]]: rulesChecked,
            })}
          />
          <div>
            <p>
              授权同时获得本车辆位置信息。本救援服务为拖车服务，具体服务细则及可能产生的费用情况，请详细查看拖车救援信息卡及
              <a
                className={styles["rescue-rules-detail"]}
                onClick={onViewRulesDetail}
                href={"/rules"}
              >
                《道路救援服务细则》
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
